import { BicycleElectricIcon } from './BicycleElectricIcon';

/**
 * author: Michael Irigoyen
 * id 3923C397-5A00-472A-8FDC-FBBAAF3FA323
 * name bicycle-electric
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bicycle-electric.svg
 * tags
 * - Transportation + Other 
 */
export const BikeElectricIcon = BicycleElectricIcon;
export default BikeElectricIcon